import React, { Component } from 'react';
import axios from 'axios';
import { Configurations } from '../../../Utils/Configurations';
import moment from 'moment';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button, TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import ErrorModal from '../../../Components/ErrorModal/ErrorModal';
import { SingleDatePicker } from 'react-dates';
import ModalAlteracoes from '../../../Components/Modal-Alteracoes/Modal-Alteracoes';
import Usuario from '../../../Utils/Usuario';
import CardHighlightDetails from '../../../Components/Card-Highlight-Details/Card-Highlight-Details';
import Select from 'react-select';
import DivPermission from '../../../Components/Div-Permission/Div-Permission';
import makeAnimated from 'react-select/lib/animated';
import Geral from '../../../Utils/Geral';




class PodcastEpisodeDetails extends Component {

    constructor(props) {
        super(props);
        this.apiEpisodio = this.apiEpisodio.bind(this);
        this.salvarAlteracoes = this.salvarAlteracoes.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleOnSelectChange = this.handleOnSelectChange.bind(this);
        this.mudaStatusEpisodio = this.mudaStatusEpisodio.bind(this);
        this.toggleSucessoAlteracao = this.toggleSucessoAlteracao.bind(this);
        this.habilitaSalvar = this.habilitaSalvar.bind(this);
        this.toggleModalPendencia = this.toggleModalPendencia.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.togglePub = this.togglePub.bind(this);
        this.onChangeInput = this.onChangeInput.bind(this);
        this.voltar = this.voltar.bind(this);
        this.toggleModalAlteracoes = this.toggleModalAlteracoes.bind(this);
        this.exibeDestaque = this.exibeDestaque.bind(this);
        this.scrollToElement = this.scrollToElement.bind(this);
        this.uploadMP3 = this.uploadMP3.bind(this);
        this.removerArquivoMP3 = this.removerArquivoMP3.bind(this);
        this.toggleRemoverArquivoMP3 = this.toggleRemoverArquivoMP3.bind(this);
        this.onSelectFile = this.onSelectFile.bind(this);
        this.atualizaTags = this.atualizaTags.bind(this);
        this.setDefaultValueSubgrupos = this.setDefaultValueSubgrupos.bind(this);
        this.apiNovaListaSubgrupos = this.apiNovaListaSubgrupos.bind(this);
        this.handleSelectPeriodicos = this.handleSelectPeriodicos.bind(this);
        this.setDefaultValuePeriodico = this.setDefaultValuePeriodico.bind(this);
        this.selecionarAba = this.selecionarAba.bind(this);
        this.chamarApiEstatisticaPodcast = this.chamarApiEstatisticaPodcast.bind(this);
        this.carregaListaTags = this.carregaListaTags.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);



        this.state = {
            isLoadingEpisodio: false,
            isLoadingAlteracoes: false,
            isLoadingStatus: false,
            novoEpisodio: this.props.match.params.idPodcastEpisodio === "novo-episodio",
            NRH: Number.parseInt(this.props.match.params.idPodcastPrograma) === 1,
            temAlteracao: false,
            tags: [],
            habilitaSalvar: false,
            modalPendencia: false,
            pendencias: [],
            hasError: false,
            errorMessage: '',
            verificacaoAcesso: false,
            nomeEpisodio: '',
            descricaoEpisodio: '',
            urlMP3: '',
            idNivelAcesso: 3,
            dtPubAux: moment(),
            publico: false,
            habilitado: false,
            duracao: '',
            flagDestaqueBSMais: false,
            flagDestaqueHub: false,
            modalCadastrarDestaque: false,
            tituloDestaque: '',
            descricaoDestaque: '',
            exibeUpload: false,
            sucessoUploadMP3: false,
            modalRemoverArquivoMP3: false,
            narrador: '',
            idSubgrupoEscolhido: null,
            isLoadingNovaListaSubgrupos: false,
            listaSubgrupos: [],
            abaSelecionada: '1',
            flaApiEstatisticaPodcast: false,
            isLoadingEstatistica: true,
            listaTags: [],
            listaTagsSelecionadas: [],
            isLoadingListaTags: false,
            pesoManualPodcast: null
        }

        this.opcoesPeriodicos = [
            { label: "BS", value: 1 },
            { label: "TC", value: 3 },
            { label: "RD", value: 4 }
        ]

        this.Configurations = new Configurations();
    }

    componentWillMount() {
        let _permissoes = [1, 4, 11, 14, 20];
        const roles = Usuario.getLoggedUser.permissoes.map(item => item.numero);
        const found = roles.some(r => _permissoes.indexOf(r) >= 0);
        const foundStatistic = roles.some(r => [24].indexOf(r) >= 0);

        if (!found && !foundStatistic) {
            this.props.history.push({ pathname: '/permissao-negada' });
        }
        else {
            this.setState({
                episodio: {
                    idPodcastPrograma: this.props.match.params.idPodcastPrograma
                },
                verificacaoAcesso: true,
                nomeMidia: "Podcasts",
                permisaoEdicaoPodcast: found,
            })
        }

        this.carregaListaTags();
    }

    componentDidMount() {
        if (this.state.verificacaoAcesso) {
            if (!this.state.novoEpisodio) {
                this.apiEpisodio();
            }
            else this.setState({
                isLoadingEpisodio: false
            })
        }

        this.apiNovaListaSubgrupos();

    }

    handleOnChange(e) {
        e.preventDefault();
        const _name = e.target.name, _value = e.target.value;
        this.setState({ [_name]: _value, temAlteracao: true })
    }

    handleOnSelectChange(o) {
        this.setState({ idSubgrupoEscolhido: o.value, temAlteracao: true })
    }

    habilitaSalvar() {
        const { nomeEpisodio, dtPubAux, descricaoEpisodio, urlMP3, duracao } = this.state;
        const _nomeValido = !!nomeEpisodio && nomeEpisodio.trim() !== '';
        const _dtPubValida = !!dtPubAux;
        const _descricaoValida = descricaoEpisodio.trim() !== '';
        const _urlValida = !!urlMP3 && urlMP3.trim() !== '';
        const _duracaoValida = !!duracao && duracao > 0;


        const _infosObrigatorias = [
            { campo: "Nome", valido: _nomeValido },
            { campo: "Descrição", valido: _descricaoValida },
            { campo: "Arquivo MP3", valido: _urlValida },
            { campo: "Data de Publicação", valido: _dtPubValida },
            { campo: "Duração", valido: _duracaoValida }
        ];

        const _pendencias = _infosObrigatorias.filter(item => !item.valido);
        const _infos = _nomeValido * _dtPubValida * _descricaoValida * _urlValida * _duracaoValida;

        this.setState({ habilitaSalvar: _infos }, () => this.salvarAlteracoes(_pendencias))
    }

    salvarAlteracoes(_pend) {
        if (this.state.habilitaSalvar) {
            const _salvarEpisodio = {
                nome: this.state.nomeEpisodio,
                descricao: this.state.descricaoEpisodio,
                audio: this.state.urlMP3,
                publico: this.state.publico,
                nivelAcesso: { idNivelAcesso: parseInt(this.state.idNivelAcesso, 10) },
                dtPublicacao: moment(this.state.dtPubAux).format('DD/MM/YYYY'),
                duracao: this.state.duracao,
                habilitado: this.state.habilitado,
                narrador: this.state.narrador,
                idSubgrupo: !!this.state.idSubgrupoEscolhido ? this.state.idSubgrupoEscolhido : undefined,
                tags: this.state.tags.map(item => item.label),
                imagemAlt: this.state.imagemAlt,
                metaTitle: this.state.metaTitle,
                metaDescription: this.state.metaDescription,
                periodico: this.state.opcaoPeriodicos,
                pesoManual: parseInt(this.state.pesoManualPodcast) || 0

            }
            this.setState({ episodio: _salvarEpisodio, isLoadingAlteracoes: true }, () => {

                if (this.state.novoEpisodio) {
                    const idPodcast = this.props.match.params.idPodcastPrograma;
                    axios.post(this.Configurations.apiBasePath + `/podcasts/${idPodcast}/episodios`, _salvarEpisodio).then(response => {
                        this.toggleSucessoAlteracao();
                    }).catch(this.handleError).finally(() => this.setState({ isLoadingAlteracoes: false }));
                } else {

                    const idPodcastEpisodio = this.props.match.params.idPodcastEpisodio;
                    const idPodcastPrograma = this.props.match.params.idPodcastPrograma;
                    axios.put(this.Configurations.apiBasePath + `/podcasts/${idPodcastPrograma}/episodios/${idPodcastEpisodio}`, _salvarEpisodio).then(response => {
                        this.toggleSucessoAlteracao();
                    }).catch(this.handleError).finally(() => this.setState({ isLoadingAlteracoes: false }));
                }
            })

        } else {
            this.setState({ pendencias: _pend }, () => this.toggleModalPendencia());
        }

    }

    mudaStatusEpisodio(metodo) {
        const { idPodcastEpisodio, idPodcastPrograma } = this.state.episodio;
        this.setState({ isLoadingStatus: true });
        axios.post(this.Configurations.apiBasePath + `/podcasts/${idPodcastPrograma}/episodios/${idPodcastEpisodio}/${metodo}`).then(response => {
            this.setState({ isLoadingStatus: false })
            this.apiEpisodio();
        }).catch(this.handleError);
    }

    apiEpisodio() {
        const idPodcastEpisodio = this.props.match.params.idPodcastEpisodio,
            idPodcastPrograma = this.props.match.params.idPodcastPrograma;
        this.setState({ isLoadingEpisodio: true });
        axios.get(this.Configurations.apiBasePath + `/podcasts/${idPodcastPrograma}/episodios/${idPodcastEpisodio}`).then(response => {
            const _episodio = response.data.data;
            this.setState({
                episodio: _episodio,
                nomeEpisodio: _episodio.nome,
                descricaoEpisodio: _episodio.descricao,
                urlMP3: _episodio.audio,
                idNivelAcesso: _episodio.nivelAcesso.idNivelAcesso,
                dtPubAux: _episodio.dtPublicacao,
                duracao: _episodio.duracao,
                flagDestaqueBSMais: _episodio.destaqueBSMais,
                flagDestaqueHub: _episodio.destaqueHub,
                tituloDestaqueBSMais: _episodio.destaqueBSMais ? undefined : _episodio.nome,
                tituloDestaqueHub: _episodio.destaqueHub ? undefined : _episodio.nome,
                descricaoDestaqueBSMais: _episodio.destaqueBSMais ? undefined : _episodio.descricao,
                descricaoDestaqueHub: _episodio.destaqueHub ? undefined : _episodio.descricao,
                imagemDestaqueBSMais: _episodio.destaqueBSMais ? undefined : _episodio.imagem,
                imagemDestaqueHub: _episodio.destaqueHub ? undefined : _episodio.imagem,
                idDestaqueBSMais: _episodio.idDestaqueBSMais,
                idDestaqueHub: _episodio.idDestaqueHub,
                exibeDestaqueBSMais: _episodio.destaqueBSMais,
                exibeDestaqueHub: _episodio.destaqueHub,
                narrador: _episodio.narrador,
                listaSubgrupos: _episodio.listaSubgrupos,
                idSubgrupo: _episodio.idSubgrupo,
                idSubgrupoEscolhido: !!_episodio.idSubgrupo ? _episodio.idSubgrupo : null,
                tags: _episodio.tags.map((item, index) => {
                    return { label: item, value: item }
                }),
                imagemAlt: _episodio.imagemAlt,
                metaTitle: _episodio.metaTitle,
                metaDescription: _episodio.metaDescription,
                reproducoes: _episodio.qtdMembrosReproducoes,
                periodico: _episodio.periodico,
                habilitado: _episodio.habilitado,
                pesoManualPodcast: _episodio.pesoManual

            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingEpisodio: false }));
    }

    toggleSucessoAlteracao() {
        if (this.state.modalSucessoAlteracao) {
            this.setState({ modalSucessoAlteracao: false }, () =>
                window.history.go(-1)
            );
        } else this.setState({ modalSucessoAlteracao: true })
    }

    toggleModalPendencia() {
        this.setState({ modalPendencia: !this.state.modalPendencia })
    }

    handleRadio(e) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message || err.response.data.msg })
    }
    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    onDateChange(date) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        this.setState({ dtPubAux: date })
    }

    togglePub() { this.setState({ modalPub: !this.state.modalPub }) }

    _outsideRange(day) {
    }

    onChangeInput(e) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        const _name = e.target.name;
        this.setState({ [_name]: e.target.value });
    }

    voltar() {
        this.state.temAlteracao ? this.toggleModalAlteracoes() : window.history.go(-1)
    }

    toggleModalAlteracoes() {
        this.setState({ modalAlteracoes: !this.state.modalAlteracoes })
    }

    exibeDestaque(plataforma) {
        this.setState({ ['exibeDestaque' + plataforma]: true }, () => this.scrollToElement('informacoesDestaque' + plataforma))
    }

    scrollToElement(id) {
        var element = document.getElementById(id);
        if (!!element) element.scrollIntoView({ block: "end", behavior: "smooth" });
    }

    onSelectFile(e) {
        this.setState({ fileUpload: e.target.files[0] })
    };

    removerArquivoMP3() {
        this.setState({
            sucessoUploadMP3: false,
            sucessoDelete: true,
            exibeUpload: false,
            fileUpload: undefined,
            urlMP3: undefined,
            duracao: '',
            modalRemoverArquivoMP3: false,
            temAlteracao: true
        })

    }

    toggleRemoverArquivoMP3() {
        this.setState({ modalRemoverArquivoMP3: !this.state.modalRemoverArquivoMP3 })
    }

    uploadMP3() {
        this.setState({ isLoadingUpload: true, sucessoUploadMP3: false })
        const { idPodcastEpisodio, idPodcastPrograma } = this.props.match.params;
        const infoSubgrupo = this.state.idSubgrupoEscolhido ? `/${this.state.idSubgrupoEscolhido}` : ' '
        const formData = new FormData();
        formData.append("fileUpload", this.state.fileUpload);
        axios.post(this.Configurations.apiBasePath + `/midia/mp3/upload/${idPodcastPrograma}/${idPodcastEpisodio}${infoSubgrupo}`, formData, {
            headers: {
                "Content-Type": `multipart/form-data`,
            }
        }).then(response => {
            this.setState({
                sucessoUploadMP3: true,
                urlMP3: response.data.midia.urlPublica,
                duracao: response.data.midia.duracao,
                temAlteracao: true,
                exibeUpload: false
            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingUpload: false }));
    }

    atualizaTags(_tags) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        this.setState({ tags: _tags })
    }

    setDefaultValueSubgrupos() {
        const subgrupoEncontrado = this.state.listaSubgrupos.filter(item => item.id === this.state.idSubgrupo)

        if (subgrupoEncontrado.length > 0) {
            return { label: subgrupoEncontrado[0].nome, value: subgrupoEncontrado[0].id }
        } else {
            return null
        }
    }

    apiNovaListaSubgrupos() {
        const idPodcast = this.props.match.params.idPodcastPrograma;
        this.setState({ isLoadingNovaListaSubgrupos: true })
        axios.get(this.Configurations.apiBasePath + `/lista-subgrupos/podcasts/${idPodcast}`).then(response => {
            this.setState({
                listaSubgrupos: response.data.listaSubgrupos
            })

        }).catch(this.handleError).finally(() => this.setState({ isLoadingNovaListaSubgrupos: false }));
    }

    handleSelectPeriodicos(e, _name, o = null) {
        if (o && o.action === "clear") {
            this.setState({ [o.name]: null });
            return;
        }
        this.setState({ [_name]: { value: e.value, label: e.label }, temAlteracao: true })
    }

    setDefaultValuePeriodico() {
        const periodicoSelecionado = this.opcoesPeriodicos.filter(item => item.label === this.state.periodico)
        if (periodicoSelecionado.length > 0) {
            return periodicoSelecionado[0]
        } else {
            return null
        }
    }

    selecionarAba(tabe) {
        this.setState({ abaSelecionada: tabe })
        if (tabe === '2' && this.state.flaApiEstatisticaPodcast === false) {
            this.chamarApiEstatisticaPodcast();
        }
    }

    chamarApiEstatisticaPodcast() {
        this.setState({ isLoadingEstatistica: true });
        axios.get(this.Configurations.apiBasePath + `/podcasts/${this.props.match.params.idPodcastPrograma}/episodios/${this.props.match.params.idPodcastEpisodio}/estatistica`).then(response => {
            this.setState({
                flaApiEstatisticaPodcast: true,
                estatisticasPodcast: response.data.data
            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingEstatistica: false }))
    }

    carregaListaTags() {
        this.setState({ isLoadingListaTags: true })
        axios.get(this.Configurations.apiBasePath + `/tags`).then(response => {
            const _tagsOptions = response.data.data.map(item => ({
                label: item.nomeTag, value: item.nomeTag
            }))
            this.setState({ listaTags: _tagsOptions })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingListaTags: false }))
    }

    handleSelectChange(e, o) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true })
        let _list = this.state.tags;

        switch (o.action) {
            case "remove-value":
                const _index = _list.findIndex(item => item === o.removedValue);
                _list.splice(_index, 1);
                break;
            case "clear":
                _list = [];
                return o;
            default:
                _list.push(o.option);
                break;
        }
        this.setState({ tags: _list });
        return o;
    }

    pesoManual() {
        const pesos = [
            {
                peso: 0,
                nome: 'Não recomendado',
                input: 'peso0'
            },
            {
                peso: 1,
                nome: 'Nível 1',
                input: 'peso1'
            },
            {
                peso: 2,
                nome: 'Nível 2',
                input: 'peso2'
            },
            {
                peso: 3,
                nome: 'Nível 3',
                input: 'peso3'
            },
            {
                peso: 4,
                nome: 'Nível 4',
                input: 'peso4'
            },
            {
                peso: 5,
                nome: 'Nível 5',
                input: 'peso5'
            },
        ];

        return pesos
    }

    render() {
        return (
            <div className="row episode-details-podcast">
                <div className='div-podcast-episodio text-center w-100'>
                    <Nav tabs>
                        <NavItem className="d-none d-lg-block">
                            <NavLink className={this.state.abaSelecionada === '1' ? 'classe-ativada-podcast' : 'classse-inativa-podcast'} onClick={() => { this.selecionarAba('1'); }}>
                                Editar podcast
                            </NavLink>
                        </NavItem>
                        <NavItem className="d-none d-lg-block">
                            <NavLink className={this.state.abaSelecionada === '2' ? 'classe-ativada-podcast' : 'classe-inativa-podcast'} onClick={() => { this.selecionarAba('2'); }}>
                                Estatísticas do podcast
                            </NavLink>
                        </NavItem>
                    </Nav>
                </div>
                <TabContent activeTab={this.state.abaSelecionada} className="w-100">
                    <TabPane tabId="1">
                        <div className="col-12">
                            {this.state.isLoadingEpisodio ? (
                                <div className="row no-gutters">
                                    <div className="col-12 text-center py-5">
                                        <div className="spinner-border text-primary" role="status" />
                                    </div>
                                </div>
                            ) : (
                                <div className="row">
                                    <div className="col-12 col-lg-10 text-center text-lg-left py-3">
                                        <h3 className="d-none d-lg-block">{this.state.nomeMidia} - {this.state.novoEpisodio ? 'Novo Episódio' : `Episódio "${this.state.nomeEpisodio}"`}</h3>
                                        <h5 className="d-lg-none">{this.state.nomeMidia} - {this.state.novoEpisodio ? 'Novo episódio' : 'Episódio'}</h5>
                                        {!this.state.novoEpisodio && <h6 className="d-lg-none">"{this.state.nomeEpisodio}"</h6>}
                                    </div>
                                    <div className="col-12 col-lg-2 text-center text-lg-right mt-2 mt-lg-0 py-3">
                                        <button onClick={this.voltar} className="btn btn-outline-secondary">voltar</button>
                                    </div>
                                    {/* Layout desktop */}
                                    <div className="col-12 d-none d-lg-block">
                                        <div className="row no-gutters">
                                            <div className="col-4 py-3 text-left">
                                                <small><small>(*)</small> informações obrigatórias</small>
                                            </div>
                                            {!this.state.isLoadingDestaqueBSMais && !this.state.isLoadingDestaqueHub && !this.state.novoEpisodio && (
                                                <DivPermission
                                                    arrayPerm={[1, 20]}
                                                    permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}
                                                >
                                                    <div className="col-8 text-right py-3">
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <div className="row">
                                                                    <div className="col-6 text-center">
                                                                        <div className="row">
                                                                            <div className="col-12 text-center">
                                                                                {this.state.flagDestaqueBSMais && (
                                                                                    <span className="badge badge-verdeBM badge-destaque">Esse item é um destaque BS+</span>
                                                                                )}
                                                                            </div>
                                                                            <div className="col-12 mt-3 text-center">
                                                                                {this.state.permisaoEdicaoPodcast && (
                                                                                    <button className="btn btn-outline-success" type="button" name="cadastrar-destaque" onClick={() => this.exibeDestaque("BSMais")}>{this.state.flagDestaqueBSMais ? 'editar destaque' : 'cadastrar como destaque BS+'}</button>

                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-6 text-center">
                                                                        <div className="row">
                                                                            <div className="col-12 text-center">
                                                                                {this.state.flagDestaqueHub && (
                                                                                    <span className="badge badge-purple badge-destaque">Esse item é um destaque HUB</span>
                                                                                )}
                                                                            </div>
                                                                            <div className="col-12 mt-3 text-center">
                                                                                {this.state.permisaoEdicaoPodcast && (
                                                                                    <button className="btn btn-outline-success" type="button" name="cadastrar-destaque" onClick={() => this.exibeDestaque("Hub")}>{this.state.flagDestaqueHub ? 'editar destaque' : 'cadastrar como destaque HUB'}</button>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </DivPermission>
                                            )}
                                        </div>
                                    </div>
                                    {/* Layout mobile */}
                                    <div className="col-12 d-lg-none">
                                        <div className="row no-gutters">
                                            {!this.state.isLoadingDestaqueBSMais && !this.state.isLoadingDestaqueHub && !this.state.novoEpisodio && (
                                                <DivPermission
                                                    arrayPerm={[1, 20]}
                                                    permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}
                                                >
                                                    <div className="col-12 text-center">
                                                        <div className="row my-3">
                                                            <div className="col-6 text-center">
                                                                <div className="row">
                                                                    {this.state.flagDestaqueBSMais && (
                                                                        <div className="col-12 text-center">
                                                                            <span className="badge badge-verdeBM badge-destaque">Destaque BS+</span>
                                                                        </div>
                                                                    )}
                                                                    <div className="col-12 text-center my-2 pr-1">
                                                                        <button className="btn btn-sm btn-outline-success" type="button" name="cadastrar-destaque" onClick={() => this.exibeDestaque("BSMais")}>{this.state.flagDestaqueBSMais ? 'editar' : 'cadastrar destaque BS+'}</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-6 text-center">
                                                                <div className="row">
                                                                    {this.state.flagDestaqueHub && (
                                                                        <div className="col-12 text-center">
                                                                            <span className="badge badge-purple badge-destaque">Destaque HUB</span>
                                                                        </div>
                                                                    )}
                                                                    <div className="col-12 text-center pl-1 my-2">
                                                                        <button className="btn btn-sm btn-outline-success" type="button" name="cadastrar-destaque" onClick={() => this.exibeDestaque("Hub")}>{this.state.flagDestaqueHub ? 'editar' : 'cadastrar destaque HUB'}</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </DivPermission>
                                            )}
                                            <div className="col-12 text-left">
                                                <small><small>(*)</small> informações obrigatórias</small>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-12">
                                                <fieldset disabled={!this.state.permisaoEdicaoPodcast}>
                                                    <div className="row">
                                                        <div className={`col-12 col-lg-${this.state.NRH ? '4' : '6'} py-3`}>
                                                            <label>Nome<sup><small>(*)</small></sup></label>
                                                            <input name="nomeEpisodio" type="text" className="form-control" onChange={this.handleOnChange} value={this.state.nomeEpisodio} autoComplete="off" />
                                                        </div>
                                                        <div className={`col-12 col-lg-6 py-3`}>
                                                            <label>Descrição<sup><small>(*)</small></sup></label>
                                                            <input name="descricaoEpisodio" type="text" className="form-control" onChange={this.handleOnChange} value={this.state.descricaoEpisodio} autoComplete="off" />
                                                        </div>
                                                        {this.state.NRH && !this.state.isLoadingNovaListaSubgrupos && (
                                                            <div className="col-6 col-lg-2 py-3">
                                                                <div className="form-group m-0">
                                                                    <label htmlFor="ddlSubgrupos">Subgrupos</label>
                                                                    <Select
                                                                        isDisabled={!this.state.permisaoEdicaoPodcast}
                                                                        id="ddlSubgrupos"
                                                                        placeholder=""
                                                                        closeMenuOnSelect={true}
                                                                        options={this.state.listaSubgrupos.map((item, index) => {
                                                                            return { label: item.nome, value: item.id }
                                                                        })}
                                                                        onChange={this.handleOnSelectChange}
                                                                        name="Subgrupos"
                                                                        defaultValue={this.setDefaultValueSubgrupos()}
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div className="col-6 col-lg-2 py-3">
                                                            <label>Duração <small>(*)(seg)</small></label>
                                                            <input name="duracao" type="number" className="form-control" onChange={this.handleOnChange} value={this.state.duracao} autoComplete="off" />
                                                        </div>
                                                        <div className={`${this.state.NRH ? "col-12 text-center" : "col-6 text-center"} col-lg-2 offset-lg-0 py-3 text-lg-left`}>
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <label>Dt. Publicação<sup><small>(*)</small></sup></label>
                                                                </div>
                                                                <div className="col-12">
                                                                    <SingleDatePicker
                                                                        date={this.state.dtPubAux !== null ? moment(this.state.dtPubAux) : null} // momentPropTypes.momentObj or null
                                                                        onDateChange={date => this.onDateChange(date)} // PropTypes.func.isRequired
                                                                        focused={this.state.focused} // PropTypes.bool
                                                                        onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                                                                        id="your_unique_id" // PropTypes.string.isRequired,
                                                                        orientation="horizontal"
                                                                        anchorDirection="left"
                                                                        openDirection="down"
                                                                        verticalHeight={450}
                                                                        numberOfMonths={1}
                                                                        small={true}
                                                                        phrases={this._phrases}
                                                                        placeholder=""
                                                                        displayFormat="DD/MM/YY"
                                                                        isOutsideRange={this._outsideRange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-5 col-12">
                                                            {this.state.permisaoEdicaoPodcast && (
                                                                <div className="row no-gutters py-3 pb-3">
                                                                    {/* Layout desktop */}
                                                                    <div className="col-lg-12 text-lg-left pb-lg-2 pl-lg-4 d-none d-lg-block">
                                                                        <label className="my-0 align-items-center d-flex">MP3 do Podcast:<sup><small>(*)</small></sup>
                                                                            {!!this.state.urlMP3 ? (
                                                                                <>
                                                                                    <a target="_blank" rel="noopener noreferrer" href={this.state.urlMP3}><i className="fas fa-file-audio ml-2 mr-1 text-primary"></i><span className="text-primary">reproduzir MP3</span></a>
                                                                                    {this.state.isLoadingDelete ? (
                                                                                        <div className="spinner-border text-primary ml-3" role="status" />
                                                                                    ) : (
                                                                                        <span onClick={this.toggleRemoverArquivoMP3} className="cursor-pointer">
                                                                                            <i className={'far fa-trash-alt ml-3 mr-1 text-danger'}></i><span className="text-danger">remover</span>
                                                                                        </span>
                                                                                    )}
                                                                                </>
                                                                            ) : (
                                                                                <span className="cursor-pointer">
                                                                                    <i className={'fas fa-file-audio ml-3 mr-1 text-success'}></i><span className="text-success" onClick={() => this.setState({ exibeUpload: true, sucessoUploadMP3: false, sucessoDelete: false })}>novo arquivo</span>
                                                                                </span>
                                                                            )}
                                                                        </label>
                                                                    </div>
                                                                    {/* Layout mobile */}
                                                                    <div className="col-12 text-center d-lg-none my-0">
                                                                        <span>MP3 do Podcast:<sup><small>(*)</small></sup></span>
                                                                        {!!this.state.urlMP3 ? (
                                                                            <>
                                                                                <div className="row no-gutters mt-2">
                                                                                    <div className="col-7 text-left">
                                                                                        <a target="_blank" rel="noopener noreferrer" href={this.state.urlMP3}><i className="fas fa-file-audio ml-2 mr-1 text-primary"></i><span className="text-primary">reproduzir MP3</span></a>
                                                                                    </div>
                                                                                    {this.state.isLoadingDelete ? (
                                                                                        <div className="spinner-border text-primary" role="status" />
                                                                                    ) : (
                                                                                        <div className="col-5 text-right pr-3">
                                                                                            <span onClick={this.toggleRemoverArquivoMP3} className="cursor-pointer">
                                                                                                <i className={'far fa-trash-alt ml-3 mr-1 text-danger'}></i><span className="text-danger">remover</span>
                                                                                            </span>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            <span className="cursor-pointer">
                                                                                <i className={'fas fa-file-audio ml-3 mr-1 text-success'}></i><span className="text-success" onClick={() => this.setState({ exibeUpload: true, sucessoUploadMP3: false, sucessoDelete: false })}>novo arquivo</span></span>
                                                                        )}
                                                                    </div>
                                                                    {this.state.exibeUpload && (
                                                                        <div className="col-12 text-center text-lg-left py-2 d-align-items-center">
                                                                            <input name="audio" type="file" accept=".mp3" className="input-arquivo-mp3 ml-lg-4" onChange={this.onSelectFile} />
                                                                            {this.state.isLoadingUpload ? (
                                                                                <div className="spinner-border text-primary ml-3 mt-3 mt-lg-0" role="status" />
                                                                            ) : (
                                                                                <React.Fragment>
                                                                                    {!this.state.sucessoUploadMP3 && (
                                                                                        <button disabled={!this.state.fileUpload || (this.state.NRH && !this.state.listaSubgrupos)} className="btn btn-outline-success ml-lg-3 mt-3 mt-lg-0" onClick={this.uploadMP3}>Upload MP3</button>
                                                                                    )}
                                                                                </React.Fragment>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                    {this.state.sucessoUploadMP3 && (
                                                                        <div className="col-12 text-center text-lg-left py-2 pl-4">
                                                                            <p className="text-success mb-0"><i>Upload de arquivo MP3 realizado com sucesso!</i></p>
                                                                        </div>
                                                                    )}
                                                                    {this.state.sucessoDelete && (
                                                                        <div className="col-12 text-center text-lg-left py-2 pl-4">
                                                                            <p className="text-danger mb-0"><i> Arquivo MP3 removido com sucesso!</i></p>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="col-lg-3 col-12 pt-3">
                                                            <label>Narrador: </label>
                                                            <input name="narrador" type="text" className="form-control" onChange={this.handleOnChange} value={this.state.narrador} autoComplete="off" />
                                                            <p className="py-4"> Reproduções: {this.state.reproducoes}</p>
                                                        </div>
                                                        <div className="col-12 d-lg-none">
                                                            <div className="row no-gutters">
                                                                <div className="col-12 col-lg-7 text-left">
                                                                    <div className="form-group m-0">
                                                                        <label htmlFor="periodicos">Vincular a um periódico: </label>
                                                                        <Select
                                                                            isDisabled={!this.state.permisaoEdicaoPodcast}
                                                                            id="periodicos"
                                                                            placeholder="Selecione um periódico"
                                                                            closeMenuOnSelect={true}
                                                                            components={makeAnimated()}
                                                                            options={this.opcoesPeriodicos}
                                                                            onChange={(e, o) => this.handleSelectPeriodicos(e, "opcaoPeriodicos", o)}
                                                                            name="opcaoPeriodicos"
                                                                            isClearable
                                                                            defaultValue={this.setDefaultValuePeriodico()}

                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* Desktop */}
                                                        {this.state.isLoadingListaTags ? (
                                                            <div className="col-12 text-center px-3">
                                                                <div className="spinner-border text-primary " role="status" />
                                                            </div>
                                                        ) : (
                                                            <div className="col-6 col-lg-6 py-3 text-left d-none d-lg-block tags-videos-episodios">
                                                                <div className='form-group'>
                                                                    <label htmlFor="tags-videos-episodios">Tags</label>
                                                                    <Select
                                                                        isDisabled={!this.state.permisaoEdicaoPodcast}
                                                                        id="tags-artigo"
                                                                        placeholder=""
                                                                        closeMenuOnSelect={true}
                                                                        defaultValue={this.state.tags}
                                                                        isMulti
                                                                        name="tags"
                                                                        onChange={this.handleSelectChange}
                                                                        options={this.state.listaTags}

                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div className="col-12 col-lg-3">
                                                            <div className="row align-items-end">
                                                                <div className="col-12 col-lg-12 py-3">
                                                                    <label>Acesso</label>
                                                                    <div className="form-check">
                                                                        <input className="form-check-input" type="radio" name="idNivelAcesso" id="excl" checked={parseInt(this.state.idNivelAcesso, 10) === 3} value={"3"} onChange={this.onChangeInput} />
                                                                        <label className="form-check-label" htmlFor="excl">Exclusivo para assinantes</label>
                                                                    </div>
                                                                    <div className="form-check">
                                                                        <input className="form-check-input" type="radio" name="idNivelAcesso" id="assoc" checked={parseInt(this.state.idNivelAcesso, 10) === 2} value={"2"} onChange={this.onChangeInput} />
                                                                        <label className="form-check-label" htmlFor="assoc">Aberto para associados</label>
                                                                    </div>
                                                                    {/* <div className="form-check">
                                                                        <input className="form-check-input" type="radio" name="idNivelAcesso" id="nao-assoc" checked={parseInt(this.state.idNivelAcesso, 10) === 4} value={"4"} onChange={this.onChangeInput} />
                                                                        <label className="form-check-label" htmlFor="assoc">Aberto para não associados logados</label>
                                                                    </div> */}
                                                                    <div className="form-check">
                                                                        <input className="form-check-input" type="radio" name="idNivelAcesso" id="publ" checked={parseInt(this.state.idNivelAcesso, 10) === 1} value={"1"} onChange={this.onChangeInput} />
                                                                        <label className="form-check-label" htmlFor="publ">Aberto ao público</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-4 col-lg-3 py-3 text-left">
                                                            <label>Recomendação de podcast</label>
                                                            <div className="form-check">
                                                                {this.pesoManual() && this.pesoManual().map(item => (
                                                                    <div key={item.input}>
                                                                        <input className="form-check-input" type="radio" name="pesoPodcast" id={item.input} checked={parseInt(this.state.pesoManualPodcast) === item.peso} value={item.peso} onChange={this.onChangeInput} />
                                                                        <label className="form-check-label" htmlFor={item.input}>{item.nome}</label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                        {/* Mobile */}
                                                        {this.state.isLoadingListaTags ? (
                                                            <div className="col-12 text-center px-3">
                                                                <div className="spinner-border text-primary " role="status" />
                                                            </div>
                                                        ) : (
                                                            <div className="col-12 py-3 text-left tags-podcasts-episodios d-lg-none">
                                                                <div className='form-group'>
                                                                    <label htmlFor="tags-podcasts-episodios">Tags</label>
                                                                    <Select
                                                                        isDisabled={!this.state.permisaoEdicaoPodcast}
                                                                        id="tags-podcats-episodios"
                                                                        placeholder=""
                                                                        closeMenuOnSelect={true}
                                                                        defaultValue={this.state.tags}
                                                                        isMulti
                                                                        name="tags"
                                                                        onChange={this.handleSelectChange}
                                                                        options={this.state.listaTags}

                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div className="col-12">
                                                            <label>Imagem alt</label>
                                                            <input name="imagemAlt" type="text" className="form-control" onChange={this.handleOnChange} value={this.state.imagemAlt} autoComplete="off" />
                                                        </div>
                                                        <div className="col-12 mt-3">
                                                            <label>Meta title</label>
                                                            <input name="metaTitle" type="text" className="form-control" onChange={this.handleOnChange} value={this.state.metaTitle} autoComplete="off" />
                                                        </div>
                                                        <div className="col-12 mt-3">
                                                            <label>Meta description</label>
                                                            <input name="metaDescription" type="text" className="form-control" onChange={this.handleOnChange} value={this.state.metaDescription} autoComplete="off" />
                                                        </div>
                                                        <div className="col-12 py-4 text-center">
                                                            {this.state.temAlteracao && (
                                                                <p className="text-danger mb-2 mr-2"><i>As alterações ainda não foram salvas.</i></p>
                                                            )}
                                                            {this.state.isLoadingAlteracoes ? (
                                                                <div className="spinner-border text-primary" role="status" />
                                                            ) : (
                                                                <React.Fragment>
                                                                    {this.state.permisaoEdicaoPodcast && (
                                                                        <button onClick={this.habilitaSalvar} disabled={!this.state.temAlteracao} className='btn btn-outline-success'>salvar alterações</button>
                                                                    )}
                                                                </React.Fragment>
                                                            )}
                                                        </div>
                                                    </div>
                                                </fieldset>

                                            </div>
                                            <div className="col-12 col-lg-6">
                                                <div className="row no-gutters">
                                                    <div className="col-12 py-1">
                                                        <div className="row no-gutters align-items-center">
                                                            <div className="offset-2 col-8 text-center py-3">
                                                                <div className="div-img-capa" style={{ backgroundImage: `url(${this.state.urlImagem})` }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div >
                            )}
                        </div>

                        {this.state.exibeDestaqueBSMais && (
                            <DivPermission
                                arrayPerm={[1, 20]}
                                permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}
                            >
                                <div className="col-12">
                                    <div className="row mt-5 informacoes-destaque" id="informacoesDestaqueBSMais">
                                        <CardHighlightDetails
                                            tipoDestaque={3}
                                            idDestaque={this.state.idDestaqueBSMais}
                                            match={this.props.match}
                                            apiConteudo={this.apiEpisodio}
                                            plataforma={1}
                                            sigla={"PD"}
                                            itemConteudo={this.state.episodio}
                                            flagDestaque={this.state.flagDestaqueBSMais}
                                        />
                                    </div>
                                </div>
                            </DivPermission>
                        )}

                        {this.state.exibeDestaqueHub && (
                            <DivPermission
                                arrayPerm={[1, 20]}
                                permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}
                            >
                                <div className="col-12">
                                    <div className="row mt-5 informacoes-destaque" id="informacoesDestaqueHub">
                                        <CardHighlightDetails
                                            tipoDestaque={3}
                                            idDestaque={this.state.idDestaqueHub}
                                            match={this.props.match}
                                            apiConteudo={this.apiEpisodio}
                                            plataforma={2}
                                            sigla={"PD"}
                                            itemConteudo={this.state.episodio}
                                            flagDestaque={this.state.flagDestaqueHub}
                                        />
                                    </div>
                                </div>
                            </DivPermission>
                        )}
                    </TabPane>

                    <TabPane tabId="2">
                        <div className="col-12 px-3 py-3">
                            <div className="row">
                                <div className="col-12 col-lg-10 text-center text-lg-left">
                                    <h3>Estatísticas do podcast - {this.state.nomeEpisodio}</h3>
                                </div>
                                <div className="col-12 col-lg-2 text-center text-lg-right">
                                    <button onClick={this.voltar} className="btn btn-outline-secondary">voltar</button>
                                </div>
                            </div>
                        </div>
                        {this.state.isLoadingEstatistica ? (
                            <div className="col-12 text-center px-3">
                                <div className="spinner-border text-primary " role="status" />
                            </div>
                        ) : (
                            <div className="col-12 my-4 text-center">
                                <div className="card">
                                    <div className="card-header">
                                        <strong>Resumo</strong>
                                    </div>
                                    <div className="card-body">
                                        <div className="row mb-4">
                                            <div className="col-12">
                                                <div className="row text-center">
                                                    <div className="col-12 border-bottom pb-2">
                                                        <strong>Visualizações</strong>
                                                    </div>
                                                    <div className="col-12 pt-2">
                                                        <div className="row text-center">
                                                            <div className="col">
                                                                <span className="featured-number">{this.state.estatisticasPodcast.qtdMembrosAssistiram}</span><br />
                                                                <span>{this.state.estatisticasPodcast.qtdMembrosAssistiram > 1 ? 'Membros' : 'Membro'}</span>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mb-4 px-6">
                                            <div className="col-5">
                                                <div className="row">
                                                    <div className="col-12 text-center border-bottom pb-2">
                                                        <strong>Coordenadorias</strong>
                                                    </div>
                                                    <div className="col-12 pt-2">

                                                        <table className="table table-borderless table-sm">
                                                            <tbody>
                                                                {this.state.estatisticasPodcast.qtdReproducoesCoordenadoria.map((coord, index) => {
                                                                    return (<tr key={index}>
                                                                        <td className="text-left">
                                                                            <strong className="text-uppercase">{coord.coordenadoria}: </strong>
                                                                        </td>
                                                                        <td className="text-right">{coord.qtdReproducao} <small>({Geral.validarNumero(Math.round(coord.qtdReproducao / this.state.estatisticasPodcast.qtdReproducoes * 100))}%)</small></td>
                                                                    </tr>)
                                                                })
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="offset-2 col-5">
                                                <div className="row">
                                                    <div className="col-12 text-center border-bottom pb-2">
                                                        <strong>Divisão</strong>
                                                    </div>
                                                    <div className="col-12 pt-2">

                                                        <table className="table table-borderless table-sm">
                                                            <tbody>
                                                                {this.state.estatisticasPodcast.qtdReproducoesDivisao.map((divisao, index) => {
                                                                    return (<tr key={index}>
                                                                        <td className="text-left">
                                                                            <strong className="">{divisao.divisao}: </strong>
                                                                        </td>
                                                                        <td className="text-right">{divisao.qtdReproducao} <small>({Geral.validarNumero(Math.round(divisao.qtdReproducao / this.state.estatisticasPodcast.qtdReproducoes * 100))}%)</small></td>
                                                                    </tr>)
                                                                })
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-5">
                                                <div className="row">
                                                    <div className="col-12 text-center border-bottom pb-2">
                                                        <strong>Função</strong>
                                                    </div>
                                                    <div className="col-12 pt-2">

                                                        <table className="table table-borderless table-sm">
                                                            <tbody>
                                                                {this.state.estatisticasPodcast.qtdReproducoesFuncao.map((func, index) => {
                                                                    return (<tr key={index}>
                                                                        <td className="text-left">
                                                                            <strong className="">{func.funcao}: </strong>
                                                                        </td>
                                                                        <td className="text-right">{func.qtdReproducao} <small>({Geral.validarNumero(Math.round(func.qtdReproducao / this.state.estatisticasPodcast.qtdReproducoes * 100))}%)</small></td>
                                                                    </tr>)
                                                                })
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="offset-2 col-5">
                                                <div className="row">
                                                    <div className="col-12 text-center border-bottom pb-2">
                                                        <strong>Idade</strong>
                                                    </div>
                                                    <div className="col-12 pt-2">

                                                        <table className="table table-borderless table-sm">
                                                            <tbody>
                                                                {this.state.estatisticasPodcast.qtdReproducoesIdade.map((idade, index) => {
                                                                    return (<tr key={index}>
                                                                        <td className="text-left">
                                                                            <strong className="">{idade.idade}: </strong>
                                                                        </td>
                                                                        <td className="text-right">{idade.qtdReproducao} <small>({Geral.validarNumero(Math.round(idade.qtdReproducao / this.state.estatisticasPodcast.qtdReproducoes * 100))}%)</small></td>
                                                                    </tr>)
                                                                })
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-5">
                                                <div className="row">
                                                    <div className="col-12 text-center border-bottom pb-2">
                                                        <strong>Data</strong>
                                                    </div>
                                                    <div className="col-12 pt-2">

                                                        <table className="table table-borderless table-sm">
                                                            <tbody>
                                                                {this.state.estatisticasPodcast.qtdReproducoesPorData.map((data, index) => {
                                                                    return (<tr key={index}>
                                                                        <td className="text-left">
                                                                            <strong className="">{data.dtReproducao}: </strong>
                                                                        </td>
                                                                        <td className="text-right">{data.qtdReproducao} <small>({Geral.validarNumero(Math.round(data.qtdReproducao / this.state.estatisticasPodcast.qtdReproducoes * 100))}%)</small></td>
                                                                    </tr>)
                                                                })
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </TabPane>
                </TabContent>

                <Modal isOpen={this.state.modalSucessoAlteracao} toggle={this.toggleSucessoAlteracao}>
                    <ModalHeader toggle={this.toggleSucessoAlteracao}>
                        {this.state.novoEpisodio ? 'Novo Episódio' : 'Edição de Episódio'}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.novoEpisodio ? 'Novo episódio criado com sucesso! :)' : 'Alterações realizadas com sucesso! :)'}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="success" onClick={this.toggleSucessoAlteracao}>ok</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modalRemoverArquivoMP3} toggle={this.toggleRemoverArquivoMP3}>
                    <ModalHeader toggle={this.toggleRemoverArquivoMP3}>Remover MP3 do Podcast</ModalHeader>
                    <ModalBody>
                        <p className="m-0">{`Deseja remover o MP3 do Podcast?`}</p>
                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingDelete ? (
                            <div className="spinner-border text-primary" role="status" />
                        ) : (
                            <Button disabled={this.state.isLoadingDelete} color={`danger`} onClick={this.removerArquivoMP3}>confirmar</Button>
                        )}
                        {' '}<Button color="secondary" onClick={() => this.setState({ modalRemoverArquivoMP3: !this.state.modalRemoverArquivoMP3 })}>voltar</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modalPendencia} toggle={this.toggleModalPendencia}>
                    <ModalHeader toggle={this.toggleModalPendencia}>Campos obrigatórios</ModalHeader>
                    <ModalBody>
                        <p>Por favor, preencha o(s) seguinte(s) campo(s) obrigatório(s):</p>
                        <ul>
                            {this.state.pendencias && this.state.pendencias.map((item, index) => {
                                return <li key={`campo-${index}`}>{item.campo}</li>
                            })}
                        </ul>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggleModalPendencia}>ok</Button>
                    </ModalFooter>
                </Modal>

                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
                {this.state.permisaoEdicaoPodcast &&
                    <ModalAlteracoes
                        isOpen={this.state.modalAlteracoes}
                        toggle={this.toggleModalAlteracoes}
                    />
                }
            </div >
        )
    }
}

export default PodcastEpisodeDetails;